import { Brand, Buttons, FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import FinSocial from 'Assets/images/Fin_Social.svg';
import { WHATSAPP_PREVIOUS_YEAR_URL } from 'Constants/whatsappLinks';
import { openUrlInNewNavigator } from 'Utils/links';
import * as Styled from './styles';

const PreviousYearsPayLater = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.PY);
  const copysInfo = {
    '1': t('PreviousYears.provider.service.devolution'),
    '2': t('PreviousYears.provider.service.sofipo'),
    '3': t('PreviousYears.provider.service.start'),
  };

  return (
    <Styled.ThreeColLayout>
      <Styled.TitleContainer type="fds_heading_bold_H4" color="dark_500" isDesktop>
        {t('PreviousYears.title')}
      </Styled.TitleContainer>
      <FlexContainer direction="column">
        <Styled.TitleContainer type="fds_heading_bold_H4" color="dark_500">
          {t('PreviousYears.title')}
        </Styled.TitleContainer>
        <Styled.Container direction="column" align="center" gap="dimension_16">
          <Styled.LogoContainer align="center" justify="center" gap="dimension_16">
            <Brand mode="light" withIcon withText />
            <img src={FinSocial} alt="logo" />
          </Styled.LogoContainer>
          <Styled.ContentInfo direction="column" align="center" gap="dimension_24">
            <FlexContainer direction="column" align="center" gap="dimension_16">
              <Text type="headline" color="fresh" size="XS_L_S">
                {t('PreviousYear.process.provider')}
              </Text>
              <Text type="paragraphs" color="dark" size="M_M_S">
                {t('PreviousYear.process.info')}
              </Text>
            </FlexContainer>
            <FlexContainer direction="column" gap="dimension_16">
              {Object.keys(copysInfo)?.map((item, i) => (
                <FlexContainer gap="dimension_08" key={item}>
                  <Styled.BulletIcon type="fds_text_semibold_S" color="green_800">
                    {i + 1}
                  </Styled.BulletIcon>
                  <Text type="paragraphs" color="dark" size="S_S_S">
                    {copysInfo[item]}
                  </Text>
                </FlexContainer>
              ))}
            </FlexContainer>
            <Buttons.Classic
              label={t('PreviousYears.provider.start')}
              mode="success"
              size="s"
              onClick={() => openUrlInNewNavigator(WHATSAPP_PREVIOUS_YEAR_URL)}
            />
            <Text type="paragraphs" color="grey" size="XS_S_S" align="justify">
              {t('PreviousYears.provider.info')}
            </Text>
          </Styled.ContentInfo>
        </Styled.Container>
      </FlexContainer>
    </Styled.ThreeColLayout>
  );
};
export default PreviousYearsPayLater;
